import { forwardRef } from 'react'
import { cn } from '../../lib/utils'

export const Select = forwardRef(({ 
  className, 
  children, 
  error,
  placeholder = 'Select an option...',
  ...props 
}, ref) => {
  return (
    <div className="w-full">
      <select
        className={cn(
          'input',
          error && 'border-red-500 focus:ring-red-500',
          className
        )}
        ref={ref}
        {...props}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {children}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  )
})

Select.displayName = 'Select'

export default Select
